<script>
import { Cell, Image, Col, Row } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'image-name-link-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-image': Image,
        'van-row': Row,
        'van-col': Col
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label:String,
        name:String,
        imageUrl: String,
        disabled:Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: ['click-link'],

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onImageNameLinkClick() {
            if (!this.disabled) {
                this.$emit('click-link')
            }
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="image-name-link-selector van-cell no-padding">
        <van-cell 
            :class="{ disabled: disabled }"
            :title="label"
            :is-link="!disabled"
            center
            @click="onImageNameLinkClick"
        >
            <template #default>
                <van-row type="flex" justify="end">
                    <van-col class="vertical-center">
                        <van-image 
                            v-if="imageUrl"
                            :src="imageUrl" 
                            round center
                            fit="cover" 
                            width="30px" 
                            height="30px"
                        />
                    </van-col>
                    <van-col class="name-field vertical-center">
                        <van-cell :value="name"/>
                    </van-col>
                </van-row>
            </template>
        </van-cell>
    </div>
</template>

<style scoped>
.image-name-link-selector .van-cell__value {
    flex: 3;
}
</style>